import { Box, ListItemButtonProps, Stack } from '@mui/material';

import useLocales from '../../../hooks/useLocales';
import RoleBasedGuard from '../../../guards/RoleBasedGuard';
import { NavItemProps } from '../type';
import { ListItemStyle, ListItemTextStyle, ListItemIconStyle } from './style';
import { AppTooltip } from 'src/components';
import { IconChevronDown, IconChevronRight } from 'src/libraries/icons';

//
//

type Props = NavItemProps & ListItemButtonProps;

export default function NavItem({ item, depth, active, open, isCollapse, ...other }: Props) {
  const { translate } = useLocales();

  const { title, icon, info, children, disabled, caption, roles } = item;
  const styledTitle = title && title.charAt(0).toUpperCase() + title.slice(1);

  const renderContent = (
    <ListItemStyle disableRipple depth={depth} active={active} disabled={disabled} id={item?.id} {...other} isCollapse={isCollapse}>
      {/* hide icons in submenu items and add them to the menu config */}
      {(icon && depth === 1) && <ListItemIconStyle>{icon}</ListItemIconStyle>}

      {depth !== 1 && <Box sx={{ mx: 2.7 }} />}

      <ListItemTextStyle
        isCollapse={isCollapse}
        primary={translate(styledTitle)}
        isChild={depth !== 1}
        className={depth > 1 && !isCollapse && active ? 'list-item-active-pointer' : ''}
        secondary={
          caption && (
            <AppTooltip title={translate(caption)} placement="top-start">
              <span>{translate(caption)}</span>
            </AppTooltip>
          )
        }
        primaryTypographyProps={{
          noWrap: true,
        }}
        secondaryTypographyProps={{
          noWrap: true,
          variant: 'caption',
        }}
      />

      {!isCollapse && (
        <>
          {info && (
            <Box component="span" sx={{ lineHeight: 0 }}>
              {info}
            </Box>
          )}
          
          {!!children && (
            <Stack justifyContent="center" sx={{ ml: 'auto', flexShrink: 0 }}>
              {open ? <IconChevronDown size={16} /> : <IconChevronRight size={16} />}
            </Stack>
          )}
        </>
      )}
    </ListItemStyle>
  );

  return <RoleBasedGuard roles={roles}>{renderContent}</RoleBasedGuard>;
}

// ----------------------------------------------------------------------

type DotIconProps = {
  active: boolean;
};

export function DotIcon({ active }: DotIconProps) {
  return (
    <ListItemIconStyle>
      <Box
        component="span"
        sx={{
          width: 4,
          height: 4,
          borderRadius: '50%',
          bgcolor: 'text.disabled',
          transition: (theme) =>
            theme.transitions.create('transform', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(active && {
            transform: 'scale(2)',
            bgcolor: 'primary.main',
          }),
        }}
      />
    </ListItemIconStyle>
  );
}
